import type { TagLocale, TagLocaleResponse } from './types';

export function mapTagLocale(data: TagLocaleResponse): TagLocale {
  return {
    localeCode: data.locale_code,
    name: data.name,
    description: data.description,
  };
}
